import { BrowserRouter, Routes, Route } from "react-router-dom";

// import HomePage from "./pages/home";
import SelectTickets from "./pages/selectTickets";
import CreateTickets from "./pages/createTickets";
import HomePage from "./pages/home";

const Router = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/tickets/edit" element={<SelectTickets />} />
                <Route path="/tickets/create" element={<CreateTickets />} />
            </Routes>
        </BrowserRouter>
    )
}

export default Router;